/**
 * Co-Producer / Touring Partner / Project Partner form
 */

// import $ from 'jquery';
import Vue from 'vue';
import $ from 'jquery';
import _ from 'lodash';
import VeeValidate, { Validator } from 'vee-validate';
import vueSelect from 'vue-select';
import refreshToken from '../mixins/refresh-token';

const dictionary = { en: { messages: { required: 'This field is mandatory' } } };

VeeValidate.Validator.localize(dictionary);

Vue.use(VeeValidate);

Validator.extend('pdf', {
    getMessage: field => 'The ' + field + ' must be a pdf file.',
    validate: value => value[0] ? /^(.+)\.(p|P)(d|D)(f|F)$/.test(value[0].name) : true
});

Validator.extend('media', {
    getMessage: field => 'The ' + field + ' must be a valid audio / video file.',
    validate: value => value[0] ? /^(.+)\.(mp3|MP3|avi|AVI|mp4|MP4|PDF|pdf|PNG|png|JPG|jpg)$/.test(value[0].name) : true
});

Validator.extend('urlmedia', {
    getMessage: () => 'The address must be in the form http://www.website.com.',
    validate: value => value ? /^(ftp|http|https):\/\/[^ "]+$/.test(value) : true
});

Validator.extend('no_160_space', {
    getMessage: field => 'The ' + field + ' field must be a valid email address.',
    validate: function (value) {
        if (value.includes(' ')) {
            return false;
        }

        return true;
    }
});

const FormArtisticComponentConfig = {
    /**
     * Component name
     * @type {String}
     */
    name: 'form-artistic',

    props: [
        'countries',
        'projectProps',
        'token',
        'categorie',
        'previous',
        'action',
        'id',
        'professions',
        'titleProps',
        'next',
        'readOnly',
        'years',
        'errorBags',
        'teamMemberError'
    ],

    components: { 'vueSelect': vueSelect },

    mixins: [ refreshToken ],

    /**
     * Component data
     * @return {Object}
     */
    data () {
        const dataObject = {
            project: {
                team_members: [
                    {
                        country: 75,
                        form_of_address: 'Mr'
                    },
                    {
                        country: 75,
                        form_of_address: 'Mr'
                    }
                ],
                team_description: ''
            },
            min_team_member_count: 2,
            tokenVal: null
        };

        return dataObject;
    },

    methods: {
        addFormItem () {
            if (!this.readOnly) {
                this.project.team_members.push({
                    country: 75,
                    form_of_address: 'Mr',
                    example_past_projects: []
                });

                if (this.project.team_members.length >= 2) {
                    this.project.teamMemberError = false;
                }
            }
        },
        deleteFormItem (index) {
            if (!this.readOnly) {
                this.project.team_members.splice(index, 1);
                if (this.project.team_members.length >= 2) {
                    this.project.teamMemberError = false;
                }
            }
        },
        validateForm (e) {
            e.preventDefault();
            this.$validator.validateAll().then((valid) => {
                if (valid && this.project.team_members.length >= 2) {
                    let btnSpinner = $('.btn--spinner', e.target);

                    btnSpinner.addClass('right-spin');
                    e.target.submit();
                } else {
                    let fieldName = this.errors.items[0].field;

                    $([document.documentElement, document.body]).animate({
                        scrollTop: $('[name="' + fieldName + '"]').parent()
                            .offset().top - 130
                    }, 500);
                }
            })
                .catch(() => {
                    return false;
                });
        },
        readUrl (e) {
            if ($(e.target)[0].files && $(e.target)[0].files[0]) {
                let reader = new FileReader();

                reader.onload = function (event) {
                    $('#' + $(e.target).data('img-id')).attr('src', event.target.result);
                };

                reader.readAsDataURL($(e.target)[0].files[0]);
            }
        },
        removeFile (element) {
            if (!this.readOnly) {
                let name = $(element.target).attr('data-remove');

                $('[name="' + name + '"]').val('remove');
                $('[data-remove="' + name + '"]').remove();
            }
        },
        addExamplePastProject (index) {
            if (!this.readOnly) {
                this.project.team_members[index].example_past_projects.push({
                    data: '',
                    type: 'link'
                });
            }
        },
        removePastProject (index, ndx) {
            if (!this.readOnly) {
                this.project.team_members[index].example_past_projects.splice(ndx, 1);
            }
        }
    },

    /**
     * Created event handler
     * @return {Void}
     */
    created () {
        this.project = this.projectProps;
        this.tokenVal = this.token;
    },

    mounted () {
        _.each(this.errorBags, (value, fieldname) => {
            if (this.teamMemberError) {
                this.project.teamMemberError = true;
            } else {
                const field = this.$validator.fields.find({ name: fieldname });

                this.$validator.errors.add({
                    id: field.name,
                    field: field.name,
                    msg: value[0],
                    scope: this.$options.scope
                });

                field.setFlags({
                    invalid: true,
                    valid: false,
                    validated: true
                });
            }
        });

        if (this.errors.items[0] !== undefined) {
            let fieldName = this.errors.items[0].field;

            $([document.documentElement, document.body]).animate({
                scrollTop: $('[name="' + fieldName + '"]').parent()
                    .offset().top - 130
            }, 500);
        }
    },

    updated () {
        for (let i = 0; i < this.project.team_members.length; i++) {
            let fieldName = 'team_member[' + i + '][country]';
            let relatedData = this.project.team_members[i].selected_country;

            if (relatedData) {
                const field = this.$validator.fields.find({
                    name: fieldName,
                    scope: this.$options.scope
                });

                if (field) {
                    this.$validator.errors.removeById(field.id);
                }
            }
        }
    }

};

const FormArtisticComponent = Vue.extend(FormArtisticComponentConfig);

export default FormArtisticComponent;
